var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 6.73046C20.98 6.73046 20.95 6.73046 20.92 6.73046C15.63 6.20046 10.35 6.00046 5.12001 6.53046L3.08001 6.73046C2.66001 6.77046 2.29001 6.47046 2.25001 6.05046C2.21001 5.63046 2.51001 5.27046 2.92001 5.23046L4.96001 5.03046C10.28 4.49046 15.67 4.70046 21.07 5.23046C21.48 5.27046 21.78 5.64046 21.74 6.05046C21.71 6.44046 21.38 6.73046 21 6.73046Z",
    fill: "#40404D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.50001 5.72C8.46001 5.72 8.42001 5.72 8.37001 5.71C7.97001 5.64 7.69001 5.25 7.76001 4.85L7.98001 3.54C8.14001 2.58 8.36001 1.25 10.69 1.25H13.31C15.65 1.25 15.87 2.63 16.02 3.55L16.24 4.85C16.31 5.26 16.03 5.65 15.63 5.71C15.22 5.78 14.83 5.5 14.77 5.1L14.55 3.8C14.41 2.93 14.38 2.76 13.32 2.76H10.7C9.64001 2.76 9.62001 2.9 9.47001 3.79L9.24001 5.09C9.18001 5.46 8.86001 5.72 8.50001 5.72Z",
    fill: "#40404D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.21 22.7496H8.78999C5.29999 22.7496 5.15999 20.8196 5.04999 19.2596L4.39999 9.18959C4.36999 8.77959 4.68999 8.41959 5.09999 8.38959C5.51999 8.36959 5.86999 8.67959 5.89999 9.08959L6.54999 19.1596C6.65999 20.6796 6.69999 21.2496 8.78999 21.2496H15.21C17.31 21.2496 17.35 20.6796 17.45 19.1596L18.1 9.08959C18.13 8.67959 18.49 8.36959 18.9 8.38959C19.31 8.41959 19.63 8.76959 19.6 9.18959L18.95 19.2596C18.84 20.8196 18.7 22.7496 15.21 22.7496Z",
    fill: "#40404D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.66 17.25H10.33C9.91999 17.25 9.57999 16.91 9.57999 16.5C9.57999 16.09 9.91999 15.75 10.33 15.75H13.66C14.07 15.75 14.41 16.09 14.41 16.5C14.41 16.91 14.07 17.25 13.66 17.25Z",
    fill: "#40404D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z",
    fill: "#40404D"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b998082a2a849e1256c0e8e2ba3bf12e.svg";
export { ForwardRef as ReactComponent };